module.exports = __webpack_public_path__ + "static/media/Device.8473cb25.png";